import { Dictionary } from '../types/utils.types';
import { TAlertIconMap } from '../types/alert.types';

export const ALERT_ICON_MAP: Dictionary<TAlertIconMap> = {
  info: {
    name: 'infoOutline',
    color: '#2F2B82',
  },
  success: {
    name: 'success',
    color: '#1A5C2C',
  },
  warning: {
    name: 'warning',
    color: '#984F11',
  },
  error: {
    name: 'errorOutline',
    color: '#E51635',
  },
};

export const HIDE_ALERT_DEFAULT_TIME_IN_SECONDS = 5;
